// @ts-strict-ignore
import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import type { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'
import {
  currentCustomerAtom,
  currentCustomerWalletAtom,
} from 'pages/Customers/atoms/customersAtoms'
import type { BusinessCustomerType, CustomerWallet, IndividualCustomerType } from 'types/customers'
import { isBusinessCustomer, isIndividualCustomer } from '../utils'

export const getCustomerBreadcrumbs = ({
  currentCustomer,
  currentCustomerWallet,
}: {
  currentCustomer: BusinessCustomerType | IndividualCustomerType
  currentCustomerWallet: CustomerWallet
}): CustomBreadCrumbConfig[] => {
  const customerPageLink =
    currentCustomerWallet && `${PathNames.CUSTOMERS}/${currentCustomer?.reference}`

  const customerPageBreadcrumb: CustomBreadCrumbConfig[] = currentCustomer
    ? [
        ...(isBusinessCustomer(currentCustomer) && !!currentCustomer?.company?.name
          ? [
              {
                title: currentCustomer?.company?.name,
                link: customerPageLink,
              },
            ]
          : []),
        ...(isIndividualCustomer(currentCustomer) &&
        !!currentCustomer?.individual?.person?.firstName
          ? [
              {
                title: `${currentCustomer?.individual?.person?.firstName} ${currentCustomer?.individual?.person?.lastName}`,
                link: customerPageLink,
              },
            ]
          : []),
      ]
    : []

  const customerWalletPageBreadcrumb: CustomBreadCrumbConfig[] = currentCustomerWallet
    ? [
        {
          title: currentCustomerWallet?.name,
        },
      ]
    : []
  return [...customerPageBreadcrumb, ...customerWalletPageBreadcrumb]
}

const useCustomerPageBreadcrumbs = (): CustomBreadCrumbConfig[] => {
  const currentCustomer = useAtomValue(currentCustomerAtom)
  const currentCustomerWallet = useAtomValue(currentCustomerWalletAtom)

  return useMemo(
    () => getCustomerBreadcrumbs({ currentCustomer, currentCustomerWallet }),
    [currentCustomer, currentCustomerWallet]
  )
}

export default useCustomerPageBreadcrumbs
